import "#legacy/shared/client/jst.js";
import "#legacy/shared/sparkle_uber_select.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.ProviderWidget ??= {};
window.AppointmentBooking.ProviderWidget.Views ??= {};

AppointmentBooking.ProviderWidget.Views.PatientTypeSelector = class PatientTypeSelector extends Backbone.View {
  constructor() {
    super(...arguments);
    this.handlePatientTypeChanged = this.handlePatientTypeChanged.bind(this);
    this.render = this.render.bind(this);
    this.decorateSelect = this.decorateSelect.bind(this);
    this.isValidPatientType = this.isValidPatientType.bind(this);
    this.patientTypes = this.patientTypes.bind(this);
  }

  // EVENT HANDLERS
  handlePatientTypeChanged(listOptionData, _resultsListElement, _clickEvent) {
    return this.$el.trigger(
      AppointmentBooking.ProviderWidget.Events.PatientTypeSelector.patientTypeSelected,
      listOptionData.value,
    );
  }

  // RENDERING

  render() {
    this.$el.html(
      window.Sparkle.Client.jstTemplate(this.template)({
        selectedPatientType: this.model.get("selectedPatientType"),
        patient_types: this.patientTypes(),
      }),
    );
    this.decorateSelect(this.selector);
    return this;
  }

  decorateSelect(select) {
    return this.$(select).uberSelect({ search: false, selectCaret: false, onSelect: this.handlePatientTypeChanged });
  }

  isValidPatientType(patientType) {
    return Object.keys(this.patientTypes()).includes(patientType);
  }

  patientTypes() {
    return AppointmentBooking.config.i18n.patient_types;
  }
};
AppointmentBooking.ProviderWidget.Views.PatientTypeSelector.prototype.template =
  "appointment_booking/provider_widget/templates/_patient_type_selector";
AppointmentBooking.ProviderWidget.Views.PatientTypeSelector.prototype.selector = "[data-behaviour~=uber-select]";
